import React from "react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { WeaRangePicker } from "ecCom";

@observer
export default class RangePickerItem extends React.PureComponent {
  onChange = (...args) => {
    const { bindObj, itemKey, onChange } = this.props;
    bindObj.onChange(...args);
    if (typeof onChange === "function") {
      onChange(itemKey, args);
    }
  };
  render() {
    const { bindObj, c } = this.props;
    return (
      <WeaRangePicker
        ecId={`${this.props.ecId}_WeaRangePicker@6vzhsw`}
        {...bindObj.bind()}
        value={toJS(bindObj.value)}
        onChange={this.onChange}
        {...c}
        {...c.otherParams}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./comMobx/wea-switch/components/RangePickerItem.js